module.exports = __webpack_public_path__ + "static/media/kazoo.0d03c218.svg";